export const BASKET_VALID_FROM = 'validFrom';
